import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import Profile from '~/profile/Profile';

export const Route = createFileRoute('/users/$id')({
  component: UserProfileRoute,
});

function UserProfileRoute() {
  const { id } = Route.useParams();
  return <Profile userId={id} />;
}
